import { EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavigationService } from '../services/navigation.service';
import { RouteService } from '../services/route.service';
import { Component, OnInit, OnDestroy, Output } from '@angular/core';
import { NavItem } from '../navItem';
import {User} from "../User";
import {AuthService} from "../services/auth.service";
import {MerchantService} from "../services/merchant.service";
import {Merchant} from "../Merchant";
import {Router} from "@angular/router";
import {CardholderService} from "../services/cardholder.service";
import {ProfileSearchResult} from "../data/ProfileSearchResult";
import {CardholderUserService} from "../services/cardholder-user.service";

@Component({
  selector: 'app-navigation-sidebar',
  templateUrl: './navigation-sidebar.component.html',
  styleUrls: ['./navigation-sidebar.component.css']
})
export class NavigationSidebarComponent implements OnInit, OnDestroy {
  routerSub: Subscription;

  constructor(
    private routeService: RouteService,
    private authService: AuthService,
    private merchantService: MerchantService,
    private navigationService: NavigationService,
    private cardHolderUserService: CardholderUserService,
    private cardHolderService: CardholderService,
    private router: Router
  ) {}

  merchants: Merchant[] = [];
  user: User;
  navigationItems: NavItem[] = [];
  entitlements: string[] = [];
  profile: ProfileSearchResult;
  activeRoute = '';
  testMerchant: Merchant;
  clicked: string;
  @Output() navigationItemClicked: EventEmitter<boolean> = new EventEmitter();

  ngOnInit() {
    this.user = this.authService.getUser();
    if (this.user.role === 'C/H') {
      this.merchantService.getAccountableOfficialsMerchants(this.user.socialSecurity.substr(5,8),
        this.user.firstName, this.user.lastName).subscribe((data: Merchant[]) => {
        this.merchants = data});
    }
    this.clicked = '';

    this.navigationService.refreshNavigationEvent.subscribe(() => {
      this.refreshNavItems();
    });

    this.refreshNavItems();

    this.routerSub = this.routeService.routeChange.subscribe(routeInfo => {
      this.activeRoute = routeInfo.activeRoute;
    });
  }

  refreshNavItems() {
    this.navigationItems = this.navigationService
      .getEntitledNavigationItems()
      .filter(navItem => {
        return navItem.parent === undefined || navItem.parent === null;
      });
  }

  ngOnDestroy() {
    this.routerSub.unsubscribe();
  }

  navigate(nextRoute: string) {
    CardholderService.storeCardHolder(null);
    this.clicked = '';

    if (this.activeRoute == '/cardholder/accountDetails' && nextRoute === '/cardholder') {
      this.router.navigate(['']).then(() => (this.router.navigate(['/cardholder/accountDetails'])));
    }
    else {
      this.navigationItemClicked.emit(true);
    }

    //this.navigationItemClicked.emit(true);
  }

  selectMerchant(merchant: Merchant) {
    CardholderService.storeCardHolder(null);
    this.clicked = merchant.descriptionLong;
    this.testMerchant = merchant;
    // @ts-ignore
    this.cardHolderService.getCardholdersByPayrollAccount(this.testMerchant.accountNum)
      .subscribe((data) => {
        this.profile = data[0];
        CardholderService.storeCardHolder(this.profile);
        this.cardHolderService.storeCardholderResult(this.profile);
        //this.navigate();
        if (this.activeRoute == '/cardholder/accountDetails') {
          this.router.navigate(['']).then(() => (this.router.navigate(['/cardholder/accountDetails'])));
        }
        else {
          this.router.navigate(['/cardholder/accountDetails']);
        }
      });
  }

  storeRecentMerchant(merchant: Merchant): void {
    this.merchantService.storeRecentMerchant(merchant);
  }
}
